/* ==========================================================================
   NewJaisa PDP variant picker: presentation + accessibility layer.
   Scope: .product_variant_options.nj-vp (snippets/new-product-options.liquid).

   theme.js stays the source of truth and is NOT modified:
     - initVariantDropdowns() builds .selected-option, toggles .active, and on an
       option click checks the radio and dispatches "change";
     - variant_selector() resolves the variant, updates price / EMI / stock / ATC;
     - updateOptionsAvailability() adds .hidden / .not-available to values.
   This file only:
     1. marks an option .nj-vp-single when it has <= 1 visible value (static box);
     2. adds button / listbox ARIA and keyboard support;
     3. opens the popover upward when there is no room below;
     4. shows the warranty add-on price next to each paid warranty value.
   Selection is always done by clicking the theme's own <label>, i.e. exactly what
   a mouse click does. Prices are only read (from the page's ShopifyAnalytics data,
   or /products/<handle>.js as a fallback), never written.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__njVariantPicker) return;
  window.__njVariantPicker = true;

  var uid = 0;

  /* ---- warranty add-on price ------------------------------------------------
     The add-on shown is the real difference between the warranty variant and the
     first warranty value (Free 6 Month) for the currently selected RAM / storage,
     so it always matches what the cart charges. */
  var product = null;
  var productRequested = false;
  var onProductReady = [];
  var rupees = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 });

  function productHandle() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  // Fast path: Shopify already prints every variant's price and option values
  // inline (ShopifyAnalytics.meta.product), so no request is needed. Used only
  // when every variant title splits into exactly one value per option list;
  // otherwise fall back to /products/<handle>.js.
  function productFromPage(optionCount) {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    var p = meta && meta.product;
    if (!p || !p.variants || !p.variants.length || !optionCount) return null;
    var variants = [];
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i];
      if (typeof v.price !== 'number' || typeof v.public_title !== 'string') return null;
      var options = v.public_title.split(' / ');
      if (options.length !== optionCount) return null;
      variants.push({ id: v.id, price: v.price, options: options });
    }
    return { variants: variants };
  }

  function loadProduct(root, onReady) {
    if (product) { onReady(); return; }
    onProductReady.push(onReady);
    if (productRequested) return;
    var handle = productHandle();
    if (!handle) return;
    productRequested = true;
    var style = document.createElement('style');
    style.textContent = '.nj-vp .nj-vp-addon{margin-left:8px;color:#1f7a3a;font-weight:600;white-space:nowrap}';
    document.head.appendChild(style);
    var fromPage = productFromPage(root.querySelectorAll('.product-selector-option-list[data-index]').length);
    if (fromPage) {
      product = fromPage;
      onProductReady.forEach(function (fn) { fn(); });
      return;
    }
    var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(routes + 'products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return;
        product = p;
        onProductReady.forEach(function (fn) { fn(); });
      })
      .catch(function () {});
  }

  function selectedValues(root) {
    var values = {};
    Array.prototype.forEach.call(root.querySelectorAll('.product-selector-option-list[data-index]'), function (list) {
      var input = list.querySelector('input[type="radio"]:checked');
      if (input) values[list.getAttribute('data-index')] = input.value;
    });
    return values;
  }

  function findVariant(values, index, value) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var ok = true;
      for (var n = 1; n <= v.options.length && ok; n++) {
        var key = 'option' + n;
        var want = key === index ? value : values[key];
        if (want != null && v.options[n - 1] !== want) ok = false;
      }
      if (ok) return v;
    }
    return null;
  }

  function addonFor(root, list, index, value) {
    var pos = parseInt(index.replace('option', ''), 10) - 1;
    var opt = product.options && product.options[pos];
    var first = list.querySelector('input[type="radio"]');
    // first warranty value (Free 6 Month); the list renders values in product order
    var baseValue = opt && opt.values ? opt.values[0] : (first ? first.value : null);
    if (!baseValue || value === baseValue) return 0;
    var values = selectedValues(root);
    var base = findVariant(values, index, baseValue);
    var variant = findVariant(values, index, value);
    if (!base || !variant) return 0;
    return Math.max(0, Math.round((variant.price - base.price) / 100));
  }

  function syncWarranty(root) {
    if (!product) return;
    var selector = root.querySelector('.product-selector-option.select-warranty');
    var list = selector && selector.querySelector('.product-selector-option-list[data-index]');
    if (!list) return;
    var index = list.getAttribute('data-index');
    var checkedText = '';
    Array.prototype.forEach.call(list.querySelectorAll('.variant-option'), function (li) {
      var input = li.querySelector('input[type="radio"]');
      var label = li.querySelector('label.option');
      if (!input || !label) return;
      var add = addonFor(root, list, index, input.value);
      var text = add > 0 ? '+ ₹' + rupees.format(add) : '';
      var tag = label.querySelector('.nj-vp-addon');
      if (text) {
        if (!tag) {
          tag = document.createElement('span');
          tag.className = 'nj-vp-addon';
          label.appendChild(tag);
        }
        if (tag.textContent !== text) tag.textContent = text;
      } else if (tag) {
        tag.remove();
      }
      if (input.checked) checkedText = input.value + (text ? ' (' + text + ')' : '');
    });
    // theme.js copies the clicked label's text into the trigger; keep it clean
    var trigger = selector.querySelector('.selected-option');
    if (trigger && checkedText && trigger.textContent !== checkedText) trigger.textContent = checkedText;
  }

  function visibleLabels(list) {
    return Array.prototype.slice.call(list.querySelectorAll('.variant-option:not(.hidden) > label.option'));
  }

  function labelText(selector) {
    var title = selector.querySelector('.variant-title');
    if (!title) return '';
    var clone = title.cloneNode(true);
    Array.prototype.forEach.call(clone.querySelectorAll('a'), function (a) { a.remove(); });
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  function sync(selector) {
    var list = selector.querySelector('.product-selector-option-list');
    var trigger = selector.querySelector('.selected-option');
    if (!list) return;

    var count = list.querySelectorAll('.variant-option:not(.hidden)').length;
    var single = count <= 1;
    if (selector.classList.contains('nj-vp-single') !== single) {
      selector.classList.toggle('nj-vp-single', single);
    }
    if (single && selector.classList.contains('active')) selector.classList.remove('active');

    if (!list.id) list.id = 'nj-vp-list-' + (++uid);
    list.setAttribute('role', 'listbox');
    var name = labelText(selector);
    if (name) list.setAttribute('aria-label', name);

    Array.prototype.forEach.call(list.querySelectorAll('.variant-option'), function (li) {
      var input = li.querySelector('input[type="radio"]');
      var label = li.querySelector('label.option');
      li.setAttribute('role', 'none');
      if (!label) return;
      label.setAttribute('role', 'option');
      label.setAttribute('tabindex', '-1');
      label.setAttribute('aria-selected', input && input.checked ? 'true' : 'false');
      if (input && input.classList.contains('not-available')) {
        label.setAttribute('aria-disabled', 'true');
      } else {
        label.removeAttribute('aria-disabled');
      }
    });

    if (!trigger) return;
    var open = selector.classList.contains('active');
    var current = trigger.textContent.trim();
    trigger.setAttribute('aria-label', name ? name + ': ' + current : current);
    if (single) {
      trigger.removeAttribute('role');
      trigger.removeAttribute('tabindex');
      trigger.removeAttribute('aria-haspopup');
      trigger.removeAttribute('aria-expanded');
      trigger.removeAttribute('aria-controls');
    } else {
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      trigger.setAttribute('aria-controls', list.id);
    }

    // open upward only when the list does not fit below but fits better above
    var up = false;
    if (open && !single) {
      var r = trigger.getBoundingClientRect();
      var need = Math.min(list.scrollHeight, 264) + 10;
      var below = window.innerHeight - r.bottom;
      up = below < need && r.top > below;
    }
    if (selector.classList.contains('nj-vp-up') !== up) selector.classList.toggle('nj-vp-up', up);
  }

  function syncRoot(root) {
    syncWarranty(root);
    var hasChoice = false;
    Array.prototype.forEach.call(root.querySelectorAll('.product-selector-option'), function (s) {
      if (s.classList.contains('color-option')) return;
      sync(s);
      if (!s.classList.contains('nj-vp-single')) hasChoice = true;
    });
    var more = root.previousElementSibling;
    if (more && more.hasAttribute('data-nj-vp-more')) {
      if (more.hidden === hasChoice) more.hidden = !hasChoice; // text only, no click behaviour
    }
  }

  function close(selector, focusTrigger) {
    selector.classList.remove('active');
    var trigger = selector.querySelector('.selected-option');
    if (focusTrigger && trigger) trigger.focus();
  }

  function focusIn(selector, which) {
    var list = selector.querySelector('.product-selector-option-list');
    if (!list) return;
    var labels = visibleLabels(list);
    if (!labels.length) return;
    var target = labels[0];
    if (which === 'last') target = labels[labels.length - 1];
    if (which === 'checked') {
      labels.forEach(function (l) {
        var input = l.previousElementSibling;
        if (input && input.checked) target = l;
      });
    }
    target.focus();
  }

  function onKeydown(e) {
    var selector = e.target.closest && e.target.closest('.nj-vp .product-selector-option');
    if (!selector && e.key === 'Escape') {
      Array.prototype.forEach.call(document.querySelectorAll('.nj-vp .product-selector-option.active'), function (s) { close(s, false); });
      return;
    }
    if (!selector || selector.classList.contains('nj-vp-single')) return;
    var key = e.key;
    var open = selector.classList.contains('active');

    // keyboard on the trigger: same click the theme listens for
    if (e.target.classList.contains('selected-option')) {
      if (key === 'Enter' || key === ' ' || key === 'Spacebar' || key === 'ArrowDown' || key === 'ArrowUp') {
        e.preventDefault();
        if (!open || key === 'Enter' || key === ' ' || key === 'Spacebar') e.target.click();
        if (selector.classList.contains('active')) {
          setTimeout(function () { focusIn(selector, 'checked'); }, 0);
        }
      } else if (key === 'Escape' && open) {
        e.preventDefault();
        close(selector, true);
      }
      return;
    }

    // keyboard inside the open list
    var label = e.target.closest('label.option');
    if (!label || !open) return;
    var labels = visibleLabels(selector.querySelector('.product-selector-option-list'));
    var i = labels.indexOf(label);
    if (key === 'ArrowDown' || key === 'ArrowUp') {
      e.preventDefault();
      var next = labels[(i + (key === 'ArrowDown' ? 1 : -1) + labels.length) % labels.length];
      if (next) next.focus();
    } else if (key === 'Home' || key === 'End') {
      e.preventDefault();
      focusIn(selector, key === 'Home' ? 'first' : 'last');
    } else if (key === 'Enter' || key === ' ' || key === 'Spacebar') {
      e.preventDefault();
      label.click(); // identical to a mouse click: theme.js handles the selection
      var trigger = selector.querySelector('.selected-option');
      if (trigger) trigger.focus();
    } else if (key === 'Escape') {
      e.preventDefault();
      close(selector, true);
    } else if (key === 'Tab') {
      close(selector, false);
    }
  }

  function watch(root) {
    if (root.__njVpWatched) return;
    root.__njVpWatched = true;
    var pending = false;
    function schedule() {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; syncRoot(root); }, 0);
    }
    new MutationObserver(schedule).observe(root, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class']
    });
    root.addEventListener('change', schedule);
    window.addEventListener('resize', schedule, { passive: true });
    loadProduct(root, schedule);
    syncRoot(root);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.product_variant_options.nj-vp'), watch);
  }

  document.addEventListener('keydown', onKeydown);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
})();
